export default __webpack_public_path__ + "static/media/dot-ornament.a68d9ed8.svg";